import { callApi } from '@local_modules/generic/fetch.js'

export async function callCheckVsXeroPnl (gridApi, entityId) {
  const apiResponse = await callApi('/api/data-review/check-vs-xero-pnl/:accountingOrganisationId', {
    accountingOrganisationId: entityId
  }, { method: 'GET' })

  console.log('apiResponse', apiResponse)

  const gridRowNode = gridApi.getRowNode(entityId)
  gridRowNode.data.checkXeroDataDone = true
}
